export const FIRESTORE_COLLECTIONS = {
  usersPrivateData: 'dynamicData/v.2/usersPrivateData',
  breathworks: 'staticData/v.2/breathworks',
  publicBreathworks: 'staticData/v.2/publicBreathworks',
  activities: 'staticData/v.2/activities',
  benefits: 'staticData/v.2/benefits',
  chakras: 'staticData/v.2/chakras',
  feelings: 'staticData/v.2/feelings',
  achievements: 'staticData/v.2/achievements',
  engagementNotifications: 'staticData/v.2/engagementNotifications',
  journeys: 'staticData/v.2/journeys',
  publicJourneys: 'staticData/v.2/publicJourneys',
  wizardBreathworksConfigs: 'staticData/v.2/wizardBreathworksConfigs',
} as const;

export function userWorkoutsPath(uid: string): string {
  return `dynamicData/v.2/usersPrivateData/${uid}/workouts`;
}

export function userAchievementsPath(uid: string): string {
  return `dynamicData/v.2/usersPrivateData/${uid}/achievements`;
}

export function userJourneysPath(uid: string): string {
  return `dynamicData/v.2/usersPrivateData/${uid}/journeys`;
}
